module.exports = __webpack_public_path__ + "img/jewelry.44b70543.png";